import { Fragment, React } from 'libs/react';
import { useDealConfiguratorContext } from '../../../DealConfigureScreen';
import { Text } from 'components/Text';
import { FormGroup } from 'components/form/FormGroup';
import { FormField } from 'components/form/FormField';
import { FormSwitch } from 'components/form/FormSwitch';
import { FormInput } from 'components/form/FormInput';
import { FormSelect } from 'components/form/FormSelect';
import { useAccount } from 'components/account/AccountProvider';
import { getConfigurationFieldValue } from 'helpers/ConfigurationField';
/**
 * @component DealConfigurationPanel.tsx
 * @since 1.0.0
 */
export function DealConfigurationPanel(props) {
    var _a, _b;
    const {} = props;
    const account = useAccount();
    const { deal, updateDealField } = useDealConfiguratorContext();
    const hasPDF = getConfigurationFieldValue((_a = account.configs) !== null && _a !== void 0 ? _a : [], 'HAS_PDF');
    return (React.createElement(Fragment, null,
        React.createElement(Text, { className: "deal-settings-panel-title", value: t('Configuration') }),
        React.createElement("div", null,
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormSwitch, { name: "showIncludedOptions", label: t('Show Included Options'), active: deal === null || deal === void 0 ? void 0 : deal.showIncludedOptions, onChange: (value) => {
                            updateDealField('showIncludedOptions', value, 'boolean');
                        } })),
                React.createElement(FormField, null,
                    React.createElement(FormInput, { name: "validityPeriod", type: "number", label: t('Validity Period'), value: (_b = deal === null || deal === void 0 ? void 0 : deal.validityPeriod) === null || _b === void 0 ? void 0 : _b.toString(), onChange: (value) => {
                            updateDealField('validityPeriod', value, 'number');
                        } })),
                React.createElement(FormField, null,
                    React.createElement(FormSelect, { name: "priceDisplay", label: t('Price Display'), value: deal === null || deal === void 0 ? void 0 : deal.priceDisplay, onChange: (value) => {
                            updateDealField('priceDisplay', value, 'string');
                        }, options: [
                            { value: 'ALL', label: t('Show all prices') },
                            { value: 'TOTAL', label: t('Show only totals') },
                            { value: 'LINE', label: t('Show only line prices') },
                            { value: 'NONE', label: t('No price displayed') },
                            ...(account.tag === 'spaeastman'
                                ? [{ value: 'BUNDLED', label: t('Bundled Pricing') }]
                                : [])
                        ] }))),
            React.createElement(FormGroup, null,
                React.createElement(FormField, null,
                    React.createElement(FormSwitch, { name: "canEditQuantity", label: t('Can Edit Quantity'), infos: t('If enabled, the contact can edit the quantity of the items in the deal.'), active: deal === null || deal === void 0 ? void 0 : deal.canEditQuantity, onChange: (value) => {
                            updateDealField('canEditQuantity', value, 'boolean');
                        } })),
                React.createElement(FormField, null,
                    React.createElement(FormSwitch, { name: "canBeSigned", label: t('Can Be Signed'), infos: t('If enabled, the contact can sign the deal.'), active: deal === null || deal === void 0 ? void 0 : deal.canBeSigned, onChange: (value) => {
                            updateDealField('canBeSigned', value, 'boolean');
                        } })),
                React.createElement(FormField, null,
                    React.createElement(FormSwitch, { name: "showDiscount", label: t('Show Discount'), infos: t('If enabled, the discount compared to the item price is displayed on each line of the interactive quote.'), active: deal === null || deal === void 0 ? void 0 : deal.showDiscount, onChange: (value) => {
                            updateDealField('showDiscount', value, 'boolean');
                        } })),
                hasPDF === 'TRUE' && (React.createElement(FormField, null,
                    React.createElement(FormSwitch, { name: "canGeneratePDF", label: t('Can Generate PDF'), infos: t('If enabled, the contact can generate a PDF of the deal.'), active: deal === null || deal === void 0 ? void 0 : deal.canGeneratePDF, onChange: (value) => {
                            updateDealField('canGeneratePDF', value, 'boolean');
                        } })))))));
}
